import { router } from '@inertiajs/react'
import { useI18n } from '../../../lib/useI18n'

// Active operator → portal announcement banners (ADR-0003, §6.22). One-way;
// dismissible per-user. `kind` drives the accent.
export type Announcement = {
  id: string
  kind: 'info' | 'maintenance' | 'warning'
  title: string
  body: string | null
}

// Severity → banner tone: warning is a bold red bar, maintenance a bold
// amber/yellow one, info stays neutral. Saturated fills (theme-aware via the
// design tokens) with a faint dark divider underneath.
const TONE: Record<Announcement['kind'], string> = {
  info: 'border-border bg-surface-2 text-ink',
  maintenance: 'border-black/10 bg-banner-warn text-banner-warn-ink',
  warning: 'border-black/10 bg-banner-bad text-banner-bad-ink',
}

export default function AnnouncementBanners({ announcements }: { announcements: Announcement[] }) {
  const { t } = useI18n()
  if (announcements.length === 0) return null

  return (
    <div>
      {announcements.map((announcement) => (
        <div
          key={announcement.id}
          className={`flex flex-wrap items-center justify-between gap-2 border-b px-4 py-2 text-sm ${TONE[announcement.kind]}`}
        >
          <span>
            <strong>{announcement.title}</strong>
            {announcement.body && <span className="ml-2 opacity-90">{announcement.body}</span>}
          </span>
          <button
            type="button"
            onClick={() => router.post(`/announcements/${announcement.id}/dismiss`)}
            className="rounded-[var(--radius)] border border-current px-2 py-0.5 text-xs"
          >
            {t('portal.announcements.dismiss')}
          </button>
        </div>
      ))}
    </div>
  )
}
